import * as React from "react";
import {
  Text,
  View,
  Image,
  StyleSheet,
  ScrollView,
  Dimensions,
  TouchableOpacity,
} from "react-native";
import GlobalStyles from "../../components/GlobalStyles.js";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import {
  loadUserInvestDetails,
  loadInvestTransactions,
  setCurrentInvestmentType,
  confirmedKYCSet,
  checkCacheData,
} from "../../redux/actions/InvestActions";
import Colors from "../../utilities/Color.js";
import Ellipsis from "../../components/Ellipsis";
import MenuBar from "../../components/headers/MenuBar";
import FooterBarWide from "../../components/footerBarWide";
import BackButtonTop from "../../components/BackButtonTop";
import GenericButton from "../../components/GenericButton.js"


export default function InvestHomeScreen() {
  const navigation = useNavigation();
  const headerTitle = "Invested in You";
  const sparkle = require("../../assets/res/sparkle_Alpha_LOOP.gif");

  // left this variable because it's used in box layout? might be depreiciated?
  // useSelector(
  //   (state) => state.invest.hasPendingTransaction
  // );
  const balance = useSelector((state) => state.user.userData.balance);
  const investedAmount = balance !== undefined ? balance.amountInvestedConfirmed : 0;
  const donatedAmount = balance !== undefined ? balance.amountDonated : 0;
  const pendingAmount = balance !== undefined ? balance.amountInvestedPending : 0;
  const withdrawnAmount = useSelector((state) => state.user.userAmountWithdrawn);

  var earnedAmount = investedAmount - withdrawnAmount;
  const checkPendingTransaction = pendingAmount != 0;
  const hasAnyTransactions = investedAmount != 0 || pendingAmount != 0; //if either is not 0, they've had transactions

  const transactionText = checkPendingTransaction ? "TRANSACTION PENDING" : "NO TRANSACTION YET"
  var earnedAmount = Number.parseFloat(earnedAmount);
  var pendingAmount_float = Number.parseFloat(pendingAmount);
  var confirmedAmount = Number.parseFloat(confirmedAmount);
  var LifetimeCashBack = Number.parseFloat(investedAmount)

  return (
    <View style={GlobalStyles.containerW}>
      <ScrollView style={styles.scrollView}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="4" />
            <View style={[styles.Topone, {
              alignItems: "flex-start",
              alignSelf: "center",
              width: "100%",
              maxWidth: 1090 > win.width ? 450 : 1200,
            }]}>
              <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "flex-start" }]}>
                <View style={GlobalStyles.headerTextYellow}>
                  <Text style={GlobalStyles.headingStyle}>{headerTitle}</Text>
                  <Text style={GlobalStyles.subheaderStyleWeb}>{"\n"}</Text>
                </View>
              </View>
            </View>
          </View>
        ) : (
          <View>
            <View style={styles.XXheaderContainer}>
              <View style={styles.statusBox}>
                <View style={styles.leftBox}>
                  <BackButtonTop />
                </View>
                <View style={styles.rightBox}>

                </View>
              </View>
              <View style={[GlobalStyles.headerContainerKL, { height: 70 }]}>
                <View style={GlobalStyles.headerText}>
                  <Text style={GlobalStyles.headingStyle}>{headerTitle}</Text>
                </View>
              </View>
            </View>
          </View>
        )}
        <View
          style={
            win.width > 748 ? styles.webViewContainer : styles.bodyContainerFull
          }
        >
          <View style={styles.oneThird}>
            <View style={styles.topBlock}>
              <View style={styles.amountBlock}>
                <View style={styles.headerSavingsBox}>
                  <View style={styles.investedBox}>
                    <Image style={styles.sparkle} source={sparkle} />
                    <Text style={styles.AmountLG}>
                      $
                      {earnedAmount
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                    </Text>
                    <Text style={styles.subText}>MY BALANCE</Text>
                  </View>
                  <View style={styles.donatedBox}>
                    {/*  */}
                    {checkPendingTransaction == false ? null : (
                      <>
                        <Text style={styles.subTextPending}>
                          {transactionText}
                        </Text>
                        {pendingAmount_float == 0 ? null : (
                          <>
                            <Text style={styles.AmountFUMPending}>
                              ($
                              {pendingAmount_float
                                .toFixed(2)
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                              )
                            </Text>
                          </>
                        )}
                      </>
                    )}
                  </View>
                </View>
              </View>
              <TouchableOpacity
                onPress={() =>
                  navigation.navigate("InvestInfo", { selectedInvestment: -1 })
                }
              >
                <View style={styles.headerSavingsBoxB}>
                  <View style={styles.investBlockA}>
                    <Text style={styles.investText}>
                      Details
                    </Text>
                  </View>
                  <View style={styles.investBlockB}>
                    <Ellipsis
                      onClickFunction={() =>
                        navigation.navigate("InvestInfo", {
                          selectedInvestment: -1,
                        })
                      }
                    />
                  </View>
                </View>
              </TouchableOpacity>
            </View>
          </View>
          <View style={styles.twoThird}>
            {!hasAnyTransactions ?
              <View style={styles.footerContainer}>
                <Text style={styles.headingText}>
                  Start shopping now and see your cash savings stack up.</Text>
                <Text style={styles.footerText}>
                  Unlock exclusive deals. discover in-store rewards near you, and grab great cashback on gift cards.
                </Text>
              </View>
              :
              <View>
                <Text style={styles.headingText}>
                  Review your transaction history</Text>
                <GenericButton
                  buttonText='TRANSACTIONS'
                  onPress={() => navigation.navigate("SpendingInsights")}
                  buttonWidth={150}
                  buttonTextSize={12}
                />
                <Text style={styles.AmountSubText}>
                  $
                  {LifetimeCashBack
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                </Text>
                <Text style={styles.numberSubText}>LIFETIME CASHBACK</Text>
                <GenericButton
                  buttonText='WITHDRAW'
                  onPress={() => navigation.navigate("ManageFund")}
                  buttonWidth={150}
                  buttonTextSize={12}
                  buttonColor="#FFFFFF"
                  borderWidth={1}
                  borderColor="#000000"
                />
                <Text style={styles.AmountSubText}>
                  $
                  {earnedAmount
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                </Text>
                <Text style={styles.numberSubText}>AVAILABLE TO WITHDRAW</Text>
              </View>}
          </View>
        </View>
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}
const win = Dimensions.get("window");
const direction = 1090 > win.width ? "column" : "row";
const adjustablepaddingRight = 1090 > win.width ? 0 : 80;
const adjustableMaxWidth = 1090 > win.width ? 450 : 1200;
const adjustableAlignSelf = 1090 > win.width ? "center" : "";
const styles = StyleSheet.create({
  sparkle: {
    position: "absolute",
    top: 0,
    right: 5,
    width: 17,
    height: 17,
  },
  investedBox: {
    flex: 7,
    alignItems: "flex-end",
    padding: 5,
    width: "100%",
    paddingRight: 20,
    paddingBottom: 0,
  },
  donatedBox: {
    flex: 3,
    alignItems: "flex-start",
    padding: 5,
    width: "100%",
    paddingTop: 8,
    borderLeftColor: Colors.LIGHTGRAY,
    borderLeftWidth: 1,
  },
  headerSavingsBox: {
    flex: 1,
    flexDirection: "row",
    width: "100%",
    paddingBottom: 4,
    paddingTop: 5,
  },
  headerSavingsBoxB: {
    flex: 1,
    flexDirection: "row",
    width: "100%",
    paddingBottom: 4,
  },
  AmountLG: {
    fontFamily: "montserrat-bold",
    fontSize: 30,
    textAlign: "right",
    marginBottom: 2,
    color: Colors.MIDBLUE,
  },
  AmountFUMPending: {
    fontFamily: "montserrat-bold",
    fontSize: 14,
    textAlign: "left",
    marginBottom: 5,
    color: Colors.MIDGRAY,
  },
  AmountSubText: {
    textAlign: "center",
    marginTop: 30,
    fontFamily: "montserrat-medium",
    fontSize: 20,
    lineHeight: 20,
  },
  numberSubText: {
    textAlign: "center",
    fontSize: 10,
    lineHeight: 18,
    paddingBottom: 50,
    color: "#757575",
    fontFamily: "montserrat-medium",
    fontSize: 10,
    lineHeight: 16,
    paddingTop: 10,
  },
  subText: {
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "left",
    color: Colors.MIDGRAY,
  },
  subTextPending: {
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "left",
    color: Colors.DARKGRAY,
  },
  scrollView: {
    flex: 1,
    backgroundColor: Colors.WHITE,
  },
  footerContainer: {
    marginTop: 20,
  },
  footerText: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    fontSize: 10,
    lineHeight: 18,
    paddingBottom: 50,
  },
  headingText: {
    fontFamily: "montserrat-medium",
    textAlign: "center",
    fontSize: 16,
    lineHeight: 18,
    paddingBottom: 45,
  },
  investText: {
    color: "#757575",
    fontFamily: "montserrat-medium",
    textAlign: "left",
    fontSize: 12,
    lineHeight: 16,
  },
  topBlock: {
    borderColor: Colors.LIGHTGRAY,
    borderWidth: 1,
    borderRadius: 10,
    padding: 10,
    marginBottom: 50,
  },
  amountBlock: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.LIGHTGRAY,
    paddingBottom: 10,
  },
  investBlockA: {
    flex: 5,
    alignItems: "flex-start",
    paddingLeft: 5,
    marginTop: 10,
    paddingBottom: -10,
    alignSelf: "center",
  },
  investBlockB: {
    flex: 2,
    alignItems: "flex-end",
    paddingRight: 5,
    marginTop: 10,
    alignSelf: "center",
  },
  bodyContainerFull: {
    flexDirection: "column",
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 25,
    paddingRight: 25,
  },
  webViewContainer: {
    flexDirection: direction,
    paddingTop: 30,
    paddingBottom: 30,
    maxWidth: adjustableMaxWidth,
    alignSelf: adjustableAlignSelf,
    width: "100%",
    alignSelf: "center",
  },
  oneThird: {
    flex: 1,
    justifyContent: "flex-start",
    paddingRight: adjustablepaddingRight,
  },
  twoThird: {
    flex: 2,
    justifyContent: "flex-start",
    //paddingLeft: 25,
  },
  statusBox: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    height: 70,
    paddingTop: 40,
  },
  leftBox: {
    flex: 1,
    alignItems: "flex-start",
  },
  rightBox: {
    flex: 1,
    alignItems: "flex-end",
  }
});
